import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PetitionsHistoryPage } from './petitions-history';

@NgModule({
  declarations: [
    PetitionsHistoryPage,
  ],
  imports: [
    IonicPageModule.forChild(PetitionsHistoryPage),
  ],
})
export class PetitionsHistoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/petitions-history/petitions-history.module.ts